import { useMediaQuery } from "@material-ui/core";
import React from "react";

interface Props {
  smallLogo?: boolean;
}

const HeaderLogo = (props: Props) => {
  const { smallLogo } = props;

  const matchesMediaQuery = useMediaQuery("(min-width: 1920px)");

  const smallLogoWidth = matchesMediaQuery ? "initial" : "4.5vw";

  return (
    <svg
      width={smallLogo ? "57" : "120"}
      height={smallLogo ? "37" : "75"}
      viewBox="0 0 120 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        width: !smallLogo ? "100%" : smallLogoWidth,
      }}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M38.4557 47.6097C37.0566 49.368 34.8729 50.2434 31.9046 50.2434C29.1274 50.2434 27.0364 49.368 25.6398 47.6097C24.6007 46.3093 24.0591 44.4658 24.0168 42.0889C23.9508 38.0873 24.1861 35.4897 24.7171 34.3012C24.9078 33.8845 25.1398 33.4915 25.4164 33.1127C26.8156 31.1674 28.9573 30.1966 31.8415 30.1966C34.8534 30.1966 37.0566 31.0739 38.4557 32.8293C39.5161 34.1692 40.0469 36.6978 40.0469 40.4186C40.0469 43.8764 39.5161 46.2703 38.4557 47.6097ZM31.7457 26.4275C27.3129 26.4275 24.0276 27.7695 21.8874 30.4478C20.948 31.6204 20.3291 32.9691 20.0091 34.4974C19.84 35.424 19.7427 37.8805 19.7213 41.8646C19.7213 45.6773 20.5505 48.5102 22.2035 50.3582C24.3447 52.7757 27.5581 53.9838 31.8415 53.9838C36.3802 53.9838 39.7313 52.7757 41.8912 50.3582C43.5246 48.5261 44.3413 45.2338 44.3413 40.4752C44.3413 35.3756 43.5246 31.9133 41.8912 30.0816C39.7313 27.6457 36.3461 26.4275 31.7457 26.4275Z"
          fill="#ffffff"
        />
        <path
          d="M54.679 27.2203H50.3829V53.3873H54.679V40.193C54.6539 36.6408 55.1858 34.1864 56.268 32.8293C57.6452 31.1098 59.6683 30.23 62.3422 30.1966V26.4275C59.1202 26.4473 56.5644 27.1236 54.679 28.4672V27.2203Z"
          fill="#ffffff"
        />
        <path
          d="M73.7002 40.1932H89.7332C89.7517 35.3027 88.9358 31.9323 87.2793 30.0817C85.1178 27.6457 81.9058 26.4275 77.6407 26.4275C73.1061 26.4275 69.7539 27.6457 67.5919 30.0817C65.9585 31.9133 65.1439 35.209 65.1439 39.9665C65.1439 45.0644 65.9585 48.5262 67.5919 50.3584C69.7539 52.7757 73.1256 53.9839 77.7081 53.9839C82.1373 53.9839 85.4344 52.654 87.5978 49.9896C88.9142 48.3482 89.6224 46.1406 89.7332 43.3654H85.4029C85.2771 44.9502 84.8312 46.2704 84.0669 47.3291C82.6476 49.2709 80.4966 50.2434 77.6112 50.2434C74.6217 50.2434 72.4268 49.3681 71.028 47.6097C70.009 46.3267 69.4712 43.494 69.4054 39.1154C69.3217 33.1688 72.0437 30.1966 77.5803 30.1966C80.3602 30.1966 82.4452 31.0739 83.8446 32.8293C84.6296 33.8092 85.1178 34.9988 85.3088 36.3971H73.7002V40.1932Z"
          fill="#ffffff"
        />
        <path
          d="M120.068 37.7428V27.1485H115.935V28.4831C115.903 28.4607 115.872 28.4375 115.84 28.4156C113.828 27.0328 111.231 26.3401 108.049 26.3401C103.468 26.3401 100.096 27.5624 97.9344 29.9963C96.3022 31.8258 95.4869 35.2923 95.4869 40.3865C95.4869 45.1475 96.3022 48.4426 97.9344 50.273C99.7803 52.4827 102.125 53.6888 104.964 53.8993C107.762 54.0876 110.274 53.2483 112.501 51.3779V49.4219C110.445 50.4435 108.335 50.7672 106.174 50.3871C104.053 50.0095 102.451 49.0549 101.37 47.5266C100.311 46.1851 99.7803 43.7858 99.7803 40.3308C99.7803 36.6144 100.311 34.0859 101.37 32.742C102.768 30.9859 104.964 30.1083 107.955 30.1083C110.836 30.1083 112.99 31.081 114.41 33.0246C114.898 33.7073 115.249 34.4706 115.461 35.3212C115.692 36.1696 115.811 37.6816 115.811 39.8544V53.3042H120.073V38.5189C120.073 38.2481 120.071 37.9894 120.068 37.7428Z"
          fill="#ffffff"
        />
        <path
          d="M9.79644 4.01829C8.37593 5.79331 7.66559 8.3731 7.66559 11.7513V21.8635H2.98847V25.6586H7.66559V62.4843C7.66559 64.6747 7.19678 66.4145 6.26458 67.6975C4.88627 69.6224 2.79898 70.6034 0 70.6431V74.3779C4.39 74.3596 7.65373 73.0203 9.79644 70.3579C11.2168 68.5821 11.9271 66.0049 11.9271 62.6274V25.6586H19.589V21.8635H11.9271V10.3109C11.9271 8.11909 12.638 7.0345 13.7295 5.91791C15.3332 4.27713 16.8136 3.77406 19.589 3.736V0C15.2022 0.0156916 11.9364 1.35709 9.79644 4.01829Z"
          fill="#ffffff"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="120" height="75" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(HeaderLogo);
